<div class="signposting-container">
  <div class="top-row-container">
    <img [src]="signpostData.logo?.data?.attributes?.url" />
    <div class="signpost-text-container">
      <p>{{ signpostData.pre_text }}</p>
      <a href="{{ signpostData.link }}" target="_blank">{{
        signpostData.link_text
      }}</a>
    </div>
  </div>

  <div class="app-store-links-container">
    <a
      class="app-store-image"
      href="{{ signpostData.apple_store_link }}"
      target="_blank"
    >
      <img [src]="signpostData.apple_store?.data?.attributes?.url" />
    </a>
    <a
      class="app-store-image"
      href="{{ signpostData.google_play_store_link }}"
      target="_blank"
    >
      <img [src]="signpostData.google_play_store?.data?.attributes?.url" />
    </a>
  </div>
</div>
